import axios from 'axios';

const CHATBOT_API_URL = process.env.REACT_APP_CHATBOT_API_URL || 'http://localhost:3001';

const chatbotApi = axios.create({
  baseURL: CHATBOT_API_URL,
  timeout: 60000 // 60s - respostas de IA podem demorar
});

// Interceptor para adicionar token JWT
chatbotApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('sessionToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Envia mensagem para o chatbot e retorna resposta
 */
export const sendChatMessage = async (message, conversationId, context) => {
  const response = await chatbotApi.post('/api/suporte/chat', {
    message,
    conversationId,
    context
  });
  return response.data;
};

export default chatbotApi;
